import { httpService } from '~/Services/Service';
import { salvarEmExcel } from '~/Utils/Helpers';

// W-0607 — Consulta Aniversariantes (read-only, paridade UConAniver.pas).
// RESPOSTA do backend (AniversariantesController) usa snake_case (SnakeCaseNamingStrategy).
// ⚠️ QUERYSTRING de GET ([FromUri]) NÃO passa pelo formatter snake_case — o model binder
//    casa por nome de propriedade/parâmetro (case-insensitive, camelCase). Só o BODY de POST
//    é convertido. Por isso os params de query abaixo são camelCase (ex.: CobrancaService /
//    IsencaoCobranca já seguem esse contrato). Enviar snake_case faz o int [FromUri] cair
//    para 0 -> Service lança "Grupo empresa inválido." (causa do bug de vendedores no W-0607).
//
// GET /aniversariantes/grupos-empresa -> [{ codigo_grupo_empresa, apelido }]
// GET /aniversariantes/vendedores?codigoGrupoEmpresa=N -> [{ codigo_conta, nome_prestador, codigo_grupo_empresa }]
// GET /aniversariantes (querystring camelCase) -> { itens: [...], total_registros, pagina, tamanho_pagina }
//   item: { nome_contato, data_aniversario, celular, codigo_conta, razao_social,
//           codigo_cidade, cidade, estado, ddd, fone, codigo_cargo, codigo_vendedor,
//           codigo_grupo_empresa, tipo_union, codigo_cor, cor_credito }

const listarGruposEmpresa = () =>
  httpService.get('/aniversariantes/grupos-empresa');

const listarVendedores = codigoGrupoEmpresa =>
  httpService.get('/aniversariantes/vendedores', {
    params: { codigoGrupoEmpresa },
  });

// Querystring camelCase: casa com as props de ListarAniversariantesRequest ([FromUri]).
// params (entrada snake_case da página) -> { codigoGrupoEmpresa, diaIni, mesIni, diaFim,
//   mesFim, codigoVendedor (opcional), pagina, tamanhoPagina }
const listar = (params = {}) => {
  const query = {
    codigoGrupoEmpresa: params.codigo_grupo_empresa,
    diaIni: params.dia_ini,
    mesIni: params.mes_ini,
    diaFim: params.dia_fim,
    mesFim: params.mes_fim,
    pagina: params.pagina,
    tamanhoPagina: params.tamanho_pagina,
  };
  if (params.codigo_vendedor != null) {
    query.codigoVendedor = params.codigo_vendedor;
  }
  return httpService.get('/aniversariantes', { params: query });
};

// Export client-side (sem endpoint de export no backend — consulta read-only).
// urlEp sem '/' inicial dispara o caminho CSV do salvarEmExcel.
const exportarExcel = (itens = []) => {
  const payload = (itens || []).map(item => ({
    Contato: item.nome_contato,
    Aniversario: formatarDataAniversario(item.data_aniversario),
    Celular: item.celular,
    Conta: item.codigo_conta,
    RazaoSocial: item.razao_social,
    Cidade: item.cidade,
    Estado: item.estado,
    DDD: item.ddd,
    Fone: item.fone,
    Cargo: item.codigo_cargo != null ? item.codigo_cargo : '',
    Contato_Tipo: item.tipo_union,
    Vendedor: item.codigo_vendedor != null ? item.codigo_vendedor : '',
    Credito: item.cor_credito,
  }));
  return salvarEmExcel(payload, 'consulta-aniversariantes');
};

// dd/MM a partir de ISO/Date string (RN: backend devolve data_aniversario nullable).
export const formatarDataAniversario = valor => {
  if (!valor) return '';
  const data = new Date(valor);
  if (isNaN(data.getTime())) return '';
  const dia = String(data.getUTCDate()).padStart(2, '0');
  const mes = String(data.getUTCMonth() + 1).padStart(2, '0');
  return `${dia}/${mes}`;
};

export default {
  listarGruposEmpresa,
  listarVendedores,
  listar,
  exportarExcel,
};
